import { UNIT } from '../../../../constant/unit'
import { getEquipmentTypeWeightUtil } from '../get-equipment-type'
import { isBarEquipmentWeightUtil } from '../is-bar'
import { getClosestNumberArrayUtil } from '../../../../utils/array/get-closest-number'
import { WEIGHT_EQUIPMENT_TYPE, WEIGHT_EQUIPMENT_TYPE_TO_UNIT_VALUE_MAP } from '../../../../constant'

function getEquipmentWeightUtil (weight, exercise, weightUnit = UNIT.IMPERIAL) {
  if (!exercise) {
    return
  }

  const weightEquipmentType = getEquipmentTypeWeightUtil(exercise)
  if (!weightEquipmentType) {
    return
  }

  let newWeight = 0
  const weightEquipment = {}
  let weightUnitValuesMap
  let isUsingPlate
  if (isBarEquipmentWeightUtil(weightEquipmentType)) {
    const equipmentWeightMap = (
      WEIGHT_EQUIPMENT_TYPE_TO_UNIT_VALUE_MAP[weightEquipmentType]
    )
    const barWeight = (
      equipmentWeightMap[weightUnit]
    )
    weightEquipment[weightEquipmentType] = {
      [barWeight]: 1
    }
    weightEquipment[WEIGHT_EQUIPMENT_TYPE.PLATE] = {}
    newWeight += barWeight
    weight -= barWeight
    weightUnitValuesMap = (
      WEIGHT_EQUIPMENT_TYPE_TO_UNIT_VALUE_MAP[WEIGHT_EQUIPMENT_TYPE.PLATE]
    )
    isUsingPlate = true
  }

  // e.g. dumbbell, kettle bell, bands, plates alone...
  if (!weightUnitValuesMap) {
    weightUnitValuesMap = (
      WEIGHT_EQUIPMENT_TYPE_TO_UNIT_VALUE_MAP[weightEquipmentType]
    )
  }

  if (!weightUnitValuesMap) {
    return
  }

  const weightValues = weightUnitValuesMap[weightUnit]
  if (!weightValues) {
    return
  }

  if (weight <= 0 && !newWeight) {
    return
  }

  // If it's using a dumbbell, kettlebell...
  // return the closest weight
  if (!isUsingPlate) {
    const closestWeight = getClosestNumberArrayUtil(weightValues, weight)
    return {
      ...weightEquipment,
      [weightEquipmentType]: {
        [closestWeight]: 1
      }
    }
  }

  const reversedWeightValues = [...weightValues].reverse()
  reversedWeightValues.forEach(weightValue => {
    const pairOfPlate = weightValue * 2
    while (pairOfPlate <= weight) {
      if (!weightEquipment[WEIGHT_EQUIPMENT_TYPE.PLATE][weightValue]) {
        weightEquipment[WEIGHT_EQUIPMENT_TYPE.PLATE][weightValue] = 0
      }
      weightEquipment[WEIGHT_EQUIPMENT_TYPE.PLATE][weightValue] += 2
      newWeight += pairOfPlate
      weight -= pairOfPlate
    }
  })

  if (!newWeight) {
    return
  }

  return weightEquipment
}

function getWeightEquipmentValueUtil (weightEquipment) {
  if (!weightEquipment) {
    return
  }
  return Object.keys(weightEquipment)
    .reduce((weightValue, weightEquipmentType) => {
      const typeObj = weightEquipment[weightEquipmentType]
      return weightValue +
        (
          Object.keys(typeObj)
            .reduce((typeWeightVal, key) => {
              const typeEquipmentWeightVal = parseFloat(key)
              const typeEquipmentCount = typeObj[key] || 0
              return typeWeightVal +
                (
                  typeEquipmentWeightVal * typeEquipmentCount
                )
            }, 0)
        )
    }, 0)
}

export {
  getEquipmentWeightUtil,
  getWeightEquipmentValueUtil
}
